<template>
  <div class="contents">
    <kinmu-list></kinmu-list>

    <div class="button-container">
      <p class="prev-page">
        <a @click="back">戻る</a>
      </p>
    </div><!--button-container-->
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import KinmuList from '@/components/kinmu/List.vue'
import { useRoute, useRouter } from 'vue-router'
import { RouterConst } from '@/const/Router'

export default defineComponent({
  setup() {
    const router = useRouter()
    const route = useRoute()
    const from = route.query.from as string
    const back = () => {
      if (from === RouterConst.MY_TASK) {
        router.push({ name: RouterConst.MY_TASK })
      } else if (from === RouterConst.SHINSEI_LIST) {
        router.push({ name: RouterConst.SHINSEI_LIST })
      } else {
        router.push({ name: RouterConst.HOME })
      }
    }

    return {
      back
    }
  },
  components: {
    'kinmu-list': KinmuList,
  }
})
</script>
